import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "mt-5 sm:mt-6 text-center" }
const _hoisted_12 = ["disabled"]

import { translate } from "@/utils/tools";
import { computed, inject, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import DropdownComponent from "../tools/DropdownComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBlacklistCreateDialog',
  props: {
  show: Boolean,
},
  emits: ["submit", "update:show", "update:form", "created"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const isWorking = ref(false);

const selectedType = ref(
  { label: "Phone", value: "PHONE" }
);

const rewardTypeOptions = ref([
  // { label: translate("messages.rewardRedemption.normal"), value: "PHONE" },
  { label: "Phone", value: "PHONE" },
  { label: "Bank Account", value: "BANKACC" },
  { label: "Bank Account Name", value: "BANKNAME" },
  // { label: "User ID", value: "USERID" },
]);
const form = ref({
  value: null,
  reason: null,
  type: "PHONE",
  username: store.state.user.username
});
const preview = ref();
const isOnetime = ref(false);
const avaliableDays = ref<string[]>([]);
const days = ref([
  { name: translate("messages.banner.sunday"), val: "SUN" },
  { name: translate("messages.banner.monday"), val: "MON" },
  { name: translate("messages.banner.tuesday"), val: "TUE" },
  { name: translate("messages.banner.wednesday"), val: "WED" },
  { name: translate("messages.banner.thuesday"), val: "THU" },
  { name: translate("messages.banner.friday"), val: "FRI" },
  { name: translate("messages.banner.saturday"), val: "SAT" },
]);

const onSelectedType = (e: any) => {
  console.log(e);
  
  form.value.type = e.value;
  selectedType.value = e;
};

const onCreate = async () => {
  isWorking.value = true;
  if(form.value.value && form.value.reason){
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/blacklist/create`,{
        ...form.value,
      }
    );

    emit("created");
    showSync.value = false;
  } else {
    alert('Missing data!')
  }
};


const onClose = () => {
  showSync.value = false;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.blacklist.createBlacklistUser")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.blacklist.type")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: rewardTypeOptions.value,
                              modelValue: selectedType.value,
                              onOnOptionSelected: onSelectedType
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.blacklist.value")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.value) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.blacklist.value')
                            }, null, 8, _hoisted_8), [
                              [_vModelText, form.value.value]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.blacklist.reason")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.reason) = $event)),
                              placeholder: _ctx.$t('messages.blacklist.reason')
                            }, null, 8, _hoisted_10), [
                              [_vModelText, form.value.reason]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.blacklist.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: isWorking.value,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onCreate())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.blacklist.submit")), 9, _hoisted_12)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})